import { useSortable } from '@dnd-kit/sortable';
import { wrap } from '@repo/di-ez';
import { MoveCustom, ViewHideLight, EyeLight, PinFillLeft, PinLightLeft } from '@repo/go-icons';
import { Button, Switch } from '@repo/go-ui';
import { clsx } from 'clsx';

import styles from './display-settings-item.module.scss';

type Props = {
  overlay?: boolean;
  field: string;
  isPinned: boolean;
  isVisible: boolean;
  isVisibilitySwitcherDisabled: boolean;
  isDragDisabled?: boolean;
  title?: string;
  style?: React.CSSProperties;
  onColumnVisibilityChange(column: string, value: boolean): void;
  unpinColumn(field: string): void;
};

export const DisplaySettingItem = wrap<Props>(function DisplaySettingItem({
  overlay = false,
  field,
  title,
  isVisible,
  isPinned,
  isDragDisabled = false,
  onColumnVisibilityChange,
  unpinColumn,
  isVisibilitySwitcherDisabled,
  style,
}) {
  const { attributes, listeners, setNodeRef, isDragging, transform, transition } = useSortable({ id: field });

  const internalStyle = {
    transform: transform ? `translate(0, ${transform.y}px) scaleX(1) scaleY(1)` : undefined,
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      className={styles.settingItem}
      style={{
        ...internalStyle,
        ...style,
        zIndex: isDragging ? 10 : 1,
        position: 'relative',
        visibility: isDragging ? 'hidden' : 'visible',
      }}
    >
      <div className={styles.leftColumn}>
        <Button
          variant="flat"
          disabled={isDragDisabled}
          {...listeners}
          {...attributes}
          className={clsx(styles.draggingButton, overlay && styles.draggingButton__active)}
        >
          <MoveCustom />
        </Button>

        <Switch
          leftNode={<ViewHideLight />}
          rightNode={<EyeLight />}
          checked={isVisible}
          disabled={isVisibilitySwitcherDisabled}
          size="m"
          onChange={(value) => onColumnVisibilityChange(field, value)}
        />
      </div>
      <div className={styles.rightColumn}>
        <p className={styles.title}>{title}</p>
        <Button variant="flat" className={styles.unpinButton} disabled={!isPinned} onClick={() => unpinColumn(field)}>
          {isPinned ? <PinFillLeft /> : <PinLightLeft />}
        </Button>
      </div>
    </div>
  );
});
